export default "__VITE_ASSET__CTxGgbRJ__"